export default "__VITE_ASSET__DSAwCL1Y__"